import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {DDayLayers, Layers} from "../view/DDayLayers";
import {DDay} from "../DDay";
import {TimelineLite} from "gsap";
import {BlitzKriegGameMode} from "../server/BlitzKriegGameMode";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GameHelper} from "../../core/utils/GameHelper";
import {BlitzKriegParsedGameData} from "../server/data/BlitzKriegParsedGameData";
import {BlitzKriegParsedInitData} from "../server/data/BlitzKriegParsedInitData";
import {Impact} from "../Font/Impact";
import {Translation} from "../../core/utils/Translation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {BlitzkriegSymbols} from "../symbol/DDaySymbolConfig";
import {BlitzKriegSound} from "../sound/BlitzKriegSound";

export class DDayFreespinIntro extends ContinueScreen {
    private _featuresTriggered: number = 3;
    private _featuresSelected: number = 0;
    private _isAtomicWildSelected: boolean = false;
    private _lastSelectedGeneralPosition: number = -1;
    private _lastHoveredGeneralPosition: number = -1;
    private _introHoveredGenerals: boolean[] = [false, false, false, false, false];
    private _introSelectedGenerals: boolean[] = [false, false, false, false, false];
    private _introSelectedFeatures: boolean[] = [false, false, false, false, false];
    private _introLight: PIXI.spine.Spine;
    private _introTitle: PIXI.Text;
    private _introTable: PIXI.spine.Spine;
    private _introGeneralsList: PIXI.spine.Spine[] = [];
    private _introActiveFeaturesList: PIXI.spine.Spine[] = [];
    private _introActiveFeaturesTextList: PIXI.spine.Spine[] = [];
    private _introFeaturesList: PIXI.spine.Spine;
    private _introBackground: PIXI.spine.Spine;
    private _introBackgroundGFX: PIXI.Graphics;
    private _spinName: PIXI.Sprite;

    constructor() {
        super(DDayLayers.getLayer(Layers.SCREENS)!);
        this._introBackground = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introBG"));
        this._introBackground.position.set(360, 360);
        this._introBackground.alpha = 0;

        this._introFeaturesList = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introFeaturesList"));
        this._introFeaturesList.state.setAnimation(0, "normal", false);
        this._introFeaturesList.position.set(360, 360);
        this._introFeaturesList.alpha = 0;

        let general1: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introGeneral1"));
        let general2: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introGeneral2"));
        let general3: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introGeneral3"));
        let general4: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introGeneral4"));
        let general5: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introGeneral5"));

        general1.position.set(360, 360);
        general2.position.set(360, 360);
        general3.position.set(360, 360);
        general4.position.set(360, 360);
        general5.position.set(360, 360);


        general1.alpha = 0;
        general2.alpha = 0;
        general3.alpha = 0;
        general4.alpha = 0;
        general5.alpha = 0;

        this._introGeneralsList.push(general5, general4, general3, general2, general1);

        this._introTable = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introTable"));
        this._introTable.position.set(360, 360);
        this._introTable.alpha = 0;

        this._introBackgroundGFX = new PIXI.Graphics();
        this._introBackgroundGFX.visible = false;

        this._spinName = new PIXI.Sprite(DDay.assetLoader.getTextures("intro_neptune")[0]);
        this._spinName.anchor.set(0.5, 0.5);
        this._spinName.position.set(800, 150);
        this._spinName.visible = false;

        this.setGraphicsProps();

        this._introTitle = new PIXI.Text(Translation.translation("CHOOSE YOUR WEAPON"), new PIXI.TextStyle({
            fontFamily: Impact.FAMILY,
            fontSize: "60px",
            stroke: "#000000",
            strokeThickness: 10,
            fill: "#EFEBDE",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowAlpha: 0.7,
            dropShadowAngle: 90,
            dropShadowDistance: 10,
            lineJoin: "round"
        }));
        this._introTitle.anchor.set(0.5, 0.5);
        this._introTitle.position.set(360, 50);
        this._introTitle.alpha = 0;

        this._introLight = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introLight"));
        this._introLight.state.setAnimation(0, "light_loop", true);
        this._introLight.position.set(360, 360);
        this._introLight.alpha = 0;
        this._introLight.name = "Light";
        this.onOrientationChanged();
    }

    protected setGraphicsProps(): void {
        if (this._introBackgroundGFX) {
            const bounds: ScreenBounds = NolimitApplication.screenBounds;
            this._introBackgroundGFX.clear();
            this._introBackgroundGFX.beginFill(0x000000, 0.9);
            this._introBackgroundGFX.drawRect(-(bounds.width * 2), -(bounds.height * 2), bounds.width * 4, bounds.height * 4);
            this._introBackgroundGFX.endFill();
        }
    }

    public enabledFeaturesTextList() {
        let atomicWild: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introAtomicWildList"));
        let stuka: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introStukaList"));
        let bomber: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introBomberList"));
        let panzer: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introPanzerList"));
        let howitzer: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introHowitzerList"));

        atomicWild.position.set(360, 360);
        stuka.position.set(360, 360);
        bomber.position.set(360, 360);
        panzer.position.set(360, 360);
        howitzer.position.set(360, 360);

        atomicWild.name = "atomic_wild"
        stuka.name = "stuka";
        bomber.name = "bomber";
        panzer.name = "panzer";
        howitzer.name = "howitzer";

        atomicWild.alpha = 0;
        stuka.alpha = 0;
        bomber.alpha = 0;
        panzer.alpha = 0;
        howitzer.alpha = 0;

        this._introActiveFeaturesTextList.push(howitzer, bomber, panzer, stuka, atomicWild);
    }

    public show(onContinueCallBack: () => void): void {

        this._featuresSelected = 0;
        this._isAtomicWildSelected = false;
        this._introBackgroundGFX.visible = true;
        this._container.addChild(this._introBackgroundGFX, this._introBackground, this._introFeaturesList);
        this.enabledFeaturesTextList();
        BlitzKriegSound.playTrack({name: "fsIntroStart"});
        BlitzKriegSound.playTrack({name: "fsIntro"});
        this._introActiveFeaturesTextList.forEach((feature: PIXI.spine.Spine) => {
            this._container.addChild(feature);
            feature.alpha = 1;
        });
        this._introGeneralsList.forEach((feature: PIXI.spine.Spine, index: number) => {
            if (index === 2) {
                this._container.addChild(this._introTable);
            }
            this._container.addChild(feature);
            let animationName: string = this.getGeneralsAnimationName(index);
            this._introGeneralsList[index].state.setAnimation(0, animationName + "_idle", true);
            feature.alpha = 1;
        });
        this._introTable.alpha = 1;
        const fsLeft: number = DDay.model.isRestore ? DDay.model.parsedInitData.freespinsLeft : DDay.model.parsedGameData.freespinsLeft;
        this._introBackground.alpha = 1;
        this._introFeaturesList.alpha = 1;
        this._introTitle.alpha = 1;
        this._introLight.state.setAnimation(0, "light_loop", false);
        this._introLight.alpha = 1;
        this._spinName.texture = DDay.assetLoader.getTextures(DDay.commonService.getFSOrSFSName(true))[0];
        this._spinName.visible = true;
        this._container.addChild(this._spinName, this._introTitle, this._introLight);
        super.show(onContinueCallBack);
        this.checkAtomicWildSelection();
        if (DDay.model.isRestore) {
            let data: BlitzKriegParsedInitData = DDay.model.parsedInitData;
            data.fsPicks.forEach((featureRevealed: number, generalIdx: number) => {
                if (featureRevealed > -1 && featureRevealed < 4) {
                    this._featuresSelected++;
                    this._introSelectedGenerals[generalIdx] = true;
                    let activeGeneralAnim: string = this.getGeneralsAnimationName(generalIdx);
                    this._introGeneralsList[generalIdx].state.setAnimation(0, activeGeneralAnim + "_select", false);
                    let revealedFeatureIdx = this.getRevealFeatureDetails(featureRevealed, true);
                    this._introSelectedFeatures[revealedFeatureIdx.idx] = true;
                    this.enableFeatureOnScreen(revealedFeatureIdx.name, generalIdx);
                    let textListSpine: PIXI.spine.Spine = this._introActiveFeaturesTextList[this.getTextListPosition(revealedFeatureIdx.idx)];
                    textListSpine.state.setAnimation(0, textListSpine.name, true);
                    this._introLight.state.setAnimation(0, "light_loop", false);
                }
            });
            if (data.nextMode !== BlitzKriegGameMode.FS_PICK) {
                this.enableContinueButton();
            } else {
                this.startClick();
            }
        }
    }


    protected close(): TimelineLite {
        const tl = new TimelineLite();

        let mode: string = BlitzKriegGameMode.FREESPIN;
        if (this._featuresTriggered === 4) {
            mode = BlitzKriegGameMode.SUPER_FREESPIN;
        }
        DDay.backgroundView.changeBackground(mode);
        BlitzKriegSound.playTrack({name: BlitzKriegSound.FS_START});
        BlitzKriegSound.fadeAndStopSound({name: "fsIntro", to: 0, duration: 50});
        BlitzKriegSound.playTrack({name: BlitzKriegSound.FREESPIN_MUSIC});
        BlitzKriegSound.setCurrentMusicName(BlitzKriegSound.FREESPIN_MUSIC);
        tl.add(super.close());
        tl.add(() => {
            this._introBackground.alpha = 0;
            this._introFeaturesList.alpha = 0;
            this._introTable.alpha = 0;
            this._introTitle.alpha = 0;
            this._introLight.alpha = 0;
            this._introBackgroundGFX.visible = false;
            this._introActiveFeaturesTextList.forEach((feature: PIXI.spine.Spine) => {
                feature.alpha = 0;
            });
            this._introGeneralsList.forEach((feature: PIXI.spine.Spine) => {
                feature.alpha = 0;
            });
            this._featuresTriggered = 3;
            this._featuresSelected = 0;
            this._isAtomicWildSelected = false;
            this._lastHoveredGeneralPosition = -1;
            this._introHoveredGenerals = [false, false, false, false, false];
            this._introSelectedGenerals = [false, false, false, false, false];
            this._introSelectedFeatures = [false, false, false, false, false];
            this._introActiveFeaturesTextList = [];
            this._container.removeChildren();
        });
        return tl;
    }

    public applyEvents() {
        this._introGeneralsList.forEach((feature: PIXI.spine.Spine, index: number) => {
            feature.interactive = true;
            if (!this._introSelectedGenerals[index]) {
                feature.buttonMode = true;
                feature.on("mouseover", () => {
                    console.log("Hovering");
                    console.log(index);
                    if (this._featuresSelected <= this._featuresTriggered) {
                        this.enableGeneralsOnHover(index);
                        this.enableLight(index);
                        this._lastHoveredGeneralPosition = index;
                        BlitzKriegSound.playTrack({name: BlitzKriegSound.FS_INTRO_HIGHLIGHT.next()});
                    }
                });

                feature.on('mousedown', () => {
                    console.log('Mouse clicked');
                    console.log(index);
                    if (!this._introSelectedGenerals[index]) {
                        this._lastSelectedGeneralPosition = index;
                        DDay.apiPlugin.betHandler.pickAndClickBet(index, false);
                        BlitzKriegSound.playTrack({name: BlitzKriegSound.FS_INTRO_GENERAL[index]});
                        this.removeEvents();
                    }
                });

                feature.on('tap', () => {
                    console.log('Mouse clicked');
                    console.log(index);
                    if (!this._introSelectedGenerals[index]) {
                        this._lastSelectedGeneralPosition = index;
                        BlitzKriegSound.playTrack({name: BlitzKriegSound.FS_INTRO_GENERAL[index]});
                        DDay.apiPlugin.betHandler.pickAndClickBet(index, false);
                        this.removeEvents();
                    }
                });
                feature.on('mouseout', () => {
                    console.log('Mouse out');
                    console.log(index);
                    if (this._featuresSelected <= this._featuresTriggered) {
                        this.mouseHoverOutAnimation(index);
                    }
                });
            }

        });
    }

    private removeEvents() {
        this._introGeneralsList.forEach((feature: PIXI.spine.Spine, index: number) => {
            feature.interactive = false;
            feature.buttonMode = false;
            feature.off("mouseover");
            feature.off('mousedown');
            feature.off('mouseout');
            feature.off('tap');
        });
    }

    private enableFeatureOnScreen(featureName: string, generalIdx: number, isDisabled: boolean = false) {
        let featureSprite: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introFeatures"));
        featureSprite.position = this.getGeneralPositions(generalIdx);
        this._introActiveFeaturesList.push(featureSprite);
        this._container.addChild(featureSprite);
        featureSprite.state.setAnimation(0, featureName, false).onComplete = () => {
            if (featureName.includes("atomicWild")) {
                featureSprite.state.setAnimation(0, "atomicWild_Idle", true);
            }
        };
        if (isDisabled) {
            featureSprite.alpha = 0.6;
            featureSprite.tint = 0x555555;
        }
    }

    private enableAtomicFeatureOnScreen(generalIdx: number, isDisabled: boolean = false) {
        let atomicWild: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("introAtomicWildList"));
        atomicWild.name = "atomic_wild"
        let position: PIXI.Point = this.getGeneralPositions(generalIdx);
        atomicWild.position.set(position.x, position.y + 200);
        this._introActiveFeaturesList.push(atomicWild);
        this._container.addChild(atomicWild);
        atomicWild.state.setAnimation(0, atomicWild.name, true);
        if (isDisabled) {
            atomicWild.alpha = 0.6;
            atomicWild.tint = 0x555555;
        }
    }

    private getRevealFeatureDetails(index: number, isRestore: boolean = false) {
        let featureName: string = "stuka";
        let soundName: string = "fsIntroUnlockStuka";
        switch (index) {
            case 0:
                featureName = "stuka";
                soundName = "fsIntroUnlockStuka";
                break;
            case 1:
                featureName = "panzer";
                soundName = "fsIntroUnlockPanzer";
                break;
            case 2:
                featureName = "bomber";
                soundName = "fsIntroUnlockBomber";
                break;
            case 3:
                featureName = "howitzer";
                soundName = "fsIntroUnlockHowitzer";
                break;
            case 4:
                featureName = "atomicWild";
                soundName = "fsIntroUnlockAtom";
                break;
        }
        if (!isRestore) {
            BlitzKriegSound.playTrack({name: soundName});
        }
        return {name: featureName, idx: index};
    }

    private enableGeneralsOnHover(index: number) {
        if (!this._introSelectedGenerals[index]) {
            this._introHoveredGenerals[index] = true;
            let activeGeneralAnim: string = this.getGeneralsAnimationName(index);
            this._introGeneralsList[index].state.setAnimation(0, activeGeneralAnim + "_hover", false);
        }
    }

    private checkAtomicWildSelection() {
        let data: BlitzKriegParsedGameData | BlitzKriegParsedInitData;
        if (DDay.model.isRestore) {
            data = DDay.model.parsedInitData;
        } else {
            data = DDay.model.parsedGameData;
        }
        let totalSelection: number = 0;
        let isAtomicWildTriggered: boolean = false;
        let atomicWildGeneralPosition: number = -1;
        if (data.nextMode !== BlitzKriegGameMode.FS_PICK) {
            data.fsPicks.forEach((featureEnable: number) => {
                if (featureEnable > -1) {
                    totalSelection++;
                }
            });
        } else {
            data.reels.forEach((reel: string[]) => {
                reel.forEach((sym: string) => {
                    if (sym === BlitzkriegSymbols.S) {
                        totalSelection++;
                    }
                });
            });
            totalSelection = totalSelection - 1;
        }
        data.fsPicks.forEach((features: number, index: number) => {
            if (features === 4) {
                isAtomicWildTriggered = true;
                atomicWildGeneralPosition = index;
            }
        });

        this._featuresTriggered = totalSelection;
        if (isAtomicWildTriggered) {
            this._introActiveFeaturesTextList[4].state.setAnimation(0, "atomic_wild", true);
            this._featuresSelected++;
            this._isAtomicWildSelected = true;
            this._lastSelectedGeneralPosition = atomicWildGeneralPosition;
            this._introSelectedGenerals[this._lastSelectedGeneralPosition] = true;
            let activeGeneralAnim: string = this.getGeneralsAnimationName(this._lastSelectedGeneralPosition);
            this._introGeneralsList[this._lastSelectedGeneralPosition].state.setAnimation(0, activeGeneralAnim + "_select", false);
            let revealedFeatureIdx = this.getRevealFeatureDetails(4, true);
            this.enableFeatureOnScreen(revealedFeatureIdx.name, this._lastSelectedGeneralPosition);
        }
    }

    private mouseHoverOutAnimation(index: number) {
        if (!this._introSelectedGenerals[index]) {
            let tl: TimelineLite = new TimelineLite();
            this._introHoveredGenerals[index] = false;
            let resetGeneralAnim: string = this.getGeneralsAnimationName(index);
            let durr: number = this._introGeneralsList[index].spineData.findAnimation(resetGeneralAnim + "_unhover").duration;
            this._introGeneralsList[index].state.setAnimation(0, resetGeneralAnim + "_unhover", false);
            this._introLight.state.setAnimation(0, "light_loop", false);
            tl.add(() => {
                if (!this._introHoveredGenerals[index]) {
                    this._introGeneralsList[index].state.setAnimation(0, resetGeneralAnim + "_idle", true);
                }
            }, durr);
        }
    }

    private enableLight(index: number) {
        let animationName: string = this.getLightAnimationName(index);
        if (!this._introSelectedGenerals[index]) {
            this._introLight.state.setAnimation(0, animationName, false);
        }
    }

    private getLightAnimationName(index: number): string {
        let animationName: string = "";
        switch (index) {
            case 0:
                animationName = "light_gen2";
                break;
            case 1:
                animationName = "light_gen1";
                break;
            case 2:
                animationName = "light_tank";
                break;
            case 3:
                animationName = "light_navy";
                break;
            case 4:
                animationName = "light_airforce";
                break;
        }
        return animationName;
    }

    private getGeneralsAnimationName(index: number) {
        let animationName: string = "";
        switch (index) {
            case 0:
                animationName = "gen2";
                break;
            case 1:
                animationName = "gen1";
                break;
            case 2:
                animationName = "tank";
                break;
            case 3:
                animationName = "navy";
                break;
            case 4:
                animationName = "Airforce";
                break;
        }
        return animationName;
    }

    private getGeneralPositions(index: number) {
        let position: PIXI.Point = new PIXI.Point(360, 360);
        switch (index) {
            case 0:
                position = new PIXI.Point(500, 240);
                break;
            case 1:
                position = new PIXI.Point(220, 240);
                break;
            case 2:
                position = new PIXI.Point(70, 460);
                break;
            case 3:
                position = new PIXI.Point(610, 460);
                break;
            case 4:
                position = new PIXI.Point(350, 460);
                break;
        }
        return position;
    }

    private getTextListPosition(index: number) {
        let position: number = 0;
        switch (index) {
            case 0:
                position = 3;
                break;
            case 1:
                position = 2;
                break;
            case 2:
                position = 1;
                break;
            case 3:
                position = 0;
                break;
            case 4:
                position = 4;
                break;
        }
        return position;
    }

    public startClick() {
        if (DDay.apiPlugin.isReplay) {
            this._lastSelectedGeneralPosition = parseInt(DDay.model.parsedGameData!.replayNextPlayerInteraction!.selectedIndex.toString());
            DDay.apiPlugin.betHandler.pickAndClickBet(this._lastSelectedGeneralPosition, false);
        } else {
            this.applyEvents();
        }
    }

    public setResult(resolve: FlowStateController) {
        console.log("Result: ", DDay.model.parsedGameData);
        this._featuresSelected++;
        this._introSelectedGenerals[this._lastSelectedGeneralPosition] = true;
        let activeGeneralAnim: string = this.getGeneralsAnimationName(this._lastSelectedGeneralPosition);
        this._introGeneralsList[this._lastSelectedGeneralPosition].state.setAnimation(0, activeGeneralAnim + "_select", false);
        let revealedFeatureIdx = this.getRevealFeatureDetails(DDay.model.parsedGameData.fsPicks[this._lastSelectedGeneralPosition]);
        this._introSelectedFeatures[revealedFeatureIdx.idx] = true;
        this.enableFeatureOnScreen(revealedFeatureIdx.name, this._lastSelectedGeneralPosition);
        let textListSpine: PIXI.spine.Spine = this._introActiveFeaturesTextList[this.getTextListPosition(revealedFeatureIdx.idx)];
        textListSpine.state.setAnimation(0, textListSpine.name, true);
        if (DDay.model.parsedGameData.nextMode !== BlitzKriegGameMode.FS_PICK) {
            this.removeEvents();
            this._introLight.state.setAnimation(0, "light_loop", false);
            this.enableContinueButton();
            this.setContinueCallBack(() => {
                resolve.finish();
            });
        } else {
            resolve.finish();
        }
    }

    public enableContinueButton() {
        if (DDay.commonService.isPortugal()) {
            let unselectedGenIdx: number = 0;
            this._introSelectedGenerals.forEach((isSelected: boolean, index: number) => {
                if (!isSelected) {
                    unselectedGenIdx++;
                    let featureUnselectedIdx: number = 0;
                    this._introSelectedFeatures.forEach((featureSelected: boolean, featureIdx) => {
                        if (!featureSelected) {
                            featureUnselectedIdx++;
                            if (featureUnselectedIdx === unselectedGenIdx) {
                                let revealedFeatureIdx = this.getRevealFeatureDetails(featureIdx, true);
                                this.enableFeatureOnScreen(revealedFeatureIdx.name, index, true);
                            }
                        }
                    })
                }
            });
        }
        super.enableContinueButton();
    }

    public onOrientationChanged() {
        if (this._spinName) {
            this._spinName.alpha = 1;
            if (NolimitApplication.isLandscape) {
                this._spinName.position.set(800, 150);
                this._continueButton.position.set(360 - this._continueButton.width * 0.5, 600);
                if (GameHelper.isIpad()) {
                    this._spinName.position.set(700, 150);
                }
            } else {
                this._spinName.position.set(360, -50);
                const centerBottom = (NolimitApplication.screenBounds.bottom - 610) * 0.5 + 500;
                this._continueButton.position.set(360 - this._continueButton.width * 0.5, centerBottom);
                if (GameHelper.isIpad()) {
                    this._continueButton.position.set(360 - this._continueButton.width * 0.5, centerBottom - 50);
                }
            }
        }
    }
}

export enum PickAndClickButtons {
    BOMBER = "normal",
    FIGHTER = "reset",
    TANK = "tank",
    ARTILLERY = "artillery"
}

